import React from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import * as styles from './styles';

function ConfirmDialog({
    open,
    variant = 'warn',
    title,
    subMessage,
    confirmLabel = 'Yes',
    cancelLabel = 'Cancel',
    onConfirm,
    onClose,
}) {
    const isSuccess = variant === 'success';

    function renderDismissButton() {
        return (
            <Box component="button" onClick={onClose} aria-label="Close" sx={styles.dismissButton}>
                <CloseIcon sx={{ fontSize: 16 }} />
            </Box>
        );
    }

    function renderIcon() {
        return (
            <Box sx={styles.iconWrapper(isSuccess)}>
                {isSuccess
                    ? <CheckCircleOutlineRoundedIcon sx={styles.iconStyle(isSuccess)} />
                    : <WarningAmberRoundedIcon sx={styles.iconStyle(isSuccess)} />
                }
            </Box>
        );
    }

    function renderTitle() {
        return <Typography sx={styles.title}>{title}</Typography>;
    }

    function renderSubMessage() {
        return <Typography sx={styles.subMessage}>{subMessage}</Typography>;
    }

    function renderActions() {
        if (isSuccess) {
            return (
                <Box component="button" onClick={onClose} sx={styles.confirmButton}>
                    {cancelLabel === 'Cancel' ? 'Close' : cancelLabel}
                </Box>
            );
        }
        return (
            <Box sx={styles.actionsRow}>
                <Box component="button" onClick={onConfirm} sx={styles.confirmButton}>
                    {confirmLabel}
                </Box>
                <Box component="button" onClick={onClose} sx={styles.cancelButton}>
                    {cancelLabel}
                </Box>
            </Box>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            sx={styles.dialog}
            slotProps={{ backdrop: { sx: styles.backdrop } }}
        >
            {renderDismissButton()}
            {renderIcon()}
            {renderTitle()}
            {renderSubMessage()}
            {renderActions()}
        </Dialog>
    );
}

export default ConfirmDialog;
